export const TOGGLE_GROUP_SELECTION = "TOGGLE_GROUP_SELECTION";
export const SET_GROUP = "SET_GROUP";